import { useEffect } from 'react';

const META_PIXEL_ID = '728493433356235';
const GTM_ID = 'GTM-5D2XS7WD';

/**
 * Injects Meta Pixel and Google Tag Manager scripts.
 * Only runs in production (NODE_ENV === 'production').
 */
const ProductionAnalytics = () => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;

    // Meta Pixel
    if (typeof window !== 'undefined' && !window.fbq) {
      const f = window;
      const b = document;
      const e = 'script';
      const v = 'https://connect.facebook.net/en_US/fbevents.js';
      const n = (f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      });
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e);
      t.async = !0;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
      window.fbq('init', META_PIXEL_ID);
      window.fbq('track', 'PageView');
      window.fbq('track', 'CompleteRegistration', {
        value: 0,
        currency: 'INR',
      });
    }

    // Google Tag Manager
    const gtmScriptExists = document.querySelector(`script[src*="googletagmanager.com/gtm.js"]`);
    if (typeof window !== 'undefined' && !gtmScriptExists) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
      document.head.appendChild(script);

      // GTM noscript fallback iframe
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.cssText = 'display:none;visibility:hidden';
      document.body.appendChild(iframe);
    }
  }, []);

  return null;
};

export default ProductionAnalytics;
